// GENERATED — real pixel dimensions, so layout computes widths instead of guessing.
export const DIM: Record<string,[number,number]> = {
  "cut/bi_cradle": [998,893],
  "cut/bi_grandmother": [725,1075],
  "cut/bi_mother": [826,1000],
  "cut/bi_thali": [812,554],
  "cut/cl_fort": [825,542],
  "cut/cl_garland": [542,594],
  "cut/cl_goldsmith": [708,533],
  "cut/cl_saltlake": [856,347],
  "cut/cl_shrine": [505,686],
  "cut/couple": [1286,1024],
  "cut/dna": [374,1443],
  "cut/ic_idcard": [618,431],
  "cut/ic_knot": [623,226],
  "cut/ic_nameplate": [637,566],
  "cut/ic_scroll": [719,632],
  "cut/ic_village": [766,698],
  "cut/manuscript": [1300,805],
  "cut/modern_man": [735,1496],
  "cut/pp_elder": [435,885],
  "cut/pp_fatherson": [728,1139],
  "cut/pp_genealogist": [563,1180],
  "cut/pp_pandit": [720,892],
  "cut/pp_phoneman": [440,1173],
  "cut/rishi": [846,1287],
  "cut/rt_havan": [766,738],
  "cut/rt_mandap": [688,718],
  "cut/rt_pot": [610,555],
  "cut/rt_razor": [607,604],
  "cut/rt_threshold": [674,548],
  "cut/sc_bars": [614,685],
  "cut/sc_carriers": [620,708],
  "cut/sc_magnifier": [667,780],
  "cut/sc_medfile": [620,832],
  "cut/sc_ychrom": [504,805],
  "cut/vd_manuscript_open": [917,641],
  "cut/vd_sage_seated": [842,928],
  "cut/vd_sage_staff": [518,1109],
  "cut/vd_yajna": [856,939],
  "photo/ph_copperplate": [694,501],
  "photo/ph_couple": [644,1216],
  "photo/ph_elder": [463,1201],
  "photo/ph_janeu": [586,504],
  "photo/ph_kalash": [690,732],
  "photo/ph_ledgers": [775,606],
  "photo/ph_manuscript": [791,391],
  "photo/ph_modern_man": [434,1214],
  "photo/ph_sage": [674,797],
  "photo/rc_biodata": [528,794],
  "photo/rc_files": [601,761],
  "photo/rc_journal": [878,787],
  "photo/rc_register": [977,756],
  "photo/rc_statute": [548,775],
};
export const wAt = (key: string, h: number) => { const d = DIM[key]; return d ? h * d[0] / d[1] : h; };

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
